import React from "react"

import { Wrapper, Row, ColWithBg, Content } from "../pageElements"

export const Contact = () => {
  return (
    <Wrapper>
      <Row height={20}>
        <ColWithBg>
          <Content center>CONTACT</Content>
        </ColWithBg>
      </Row>
    </Wrapper>
  )
}
